// @ts-nocheck
import {
    chain,
    GetShipTos,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Data/ShipTos/Handlers/LoadCurrentShipTos";
import handleGetShipTosResult from "@store/Extensions/Store/Data/ShipTos/Handlers/handleGetShipTosResult";
import { addToChainAfter } from "@toolkit/Modules/client-framework/HandlerCreator";
import uniq from "lodash/uniq";

addToChainAfter(chain, PopulateApiParameter, props => {
    props.apiParameter.additionalExpands = uniq([...(props.apiParameter.additionalExpands || []), "includeCurrentTag"]);
});

addToChainAfter(chain, GetShipTos, handleGetShipTosResult);
